<div class="app-main__inner">

  <!-- ========== LIST VIEW ========== -->
  <div *ngIf="view === 'list'" class="bb-list-view">
    <div class="card bb-fill-card">
      <div class="card-header d-flex align-items-center justify-content-between">
        <span class="fw-semibold"><i class="pe-7s-home me-2 text-primary"></i>Centers List</span>
        <div class="d-flex align-items-center gap-2">
          <span class="badge bg-secondary">{{ records.length }} records</span>
          <button type="button" class="btn btn-primary btn-sm" (click)="addNew()">
            <i class="pe-7s-plus me-1"></i> Add New Center
          </button>
        </div>
      </div>
      <div class="card-body p-0 bb-fill-body">
        <div class="text-center py-5" *ngIf="isListLoading">
          <div class="spinner-border text-primary"></div>
          <p class="mt-2 text-muted">Loading centers...</p>
        </div>
        <vio-table-v2 *ngIf="!isListLoading" [tableData]="records" [tableConfig]="tableConfig"></vio-table-v2>
      </div>
    </div>
  </div>

  <!-- ========== FORM VIEW ========== -->
  <div *ngIf="view === 'form'" class="bb-form-view">
    <div class="bb-form-card">

      <div class="bb-form-header">
        <div class="bb-form-header__title">
          <i class="pe-7s-home"></i>
          {{ isEditMode ? 'Edit Center' : 'New Center' }}
        </div>
        <button type="button" class="bb-form-header__back" (click)="backToList()">
          <i class="pe-7s-angle-left"></i> Back
        </button>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <div class="bb-form-body">

          <div class="bb-form-section">Identity</div>
          <div class="row g-2">
            <div class="col-md-3">
              <label class="form-label">Center ID <span class="text-danger">*</span></label>
              <input type="text" formControlName="centerId" class="form-control"
                     [class.is-invalid]="isFieldInvalid('centerId')"
                     placeholder="e.g. CTR001" maxlength="20" />
              <div class="invalid-feedback">
                <span *ngIf="f['centerId'].errors?.['required']">Center ID is required.</span>
                <span *ngIf="f['centerId'].errors?.['maxlength']">Max 20 characters.</span>
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Center Name <span class="text-danger">*</span></label>
              <input type="text" formControlName="centerName" class="form-control"
                     [class.is-invalid]="isFieldInvalid('centerName')"
                     placeholder="e.g. Koregaon Park Center" maxlength="200" />
              <div class="invalid-feedback">
                <span *ngIf="f['centerName'].errors?.['required']">Center Name is required.</span>
                <span *ngIf="f['centerName'].errors?.['minlength']">Must be at least 3 characters.</span>
              </div>
            </div>
            <div class="col-md-3 d-flex align-items-end pb-1">
              <div class="form-check form-switch bb-toggle-row">
                <input class="form-check-input" type="checkbox" id="isActiveCheck" formControlName="isActive" />
                <label class="form-check-label" for="isActiveCheck">Active</label>
              </div>
            </div>
          </div>

          <div class="bb-form-section">Location</div>
          <div class="row g-2">
            <div class="col-md-6">
              <label class="form-label">Address</label>
              <input type="text" formControlName="address" class="form-control"
                     placeholder="Full address of the center" maxlength="500" />
            </div>
            <div class="col-md-4">
              <label class="form-label">Area</label>
              <input type="text" formControlName="area" class="form-control"
                     placeholder="e.g. Koregaon Park" maxlength="100" />
            </div>
            <div class="col-md-2">
              <label class="form-label">Pincode</label>
              <input type="text" formControlName="pincode" class="form-control"
                     placeholder="411001" maxlength="10" />
            </div>
          </div>

          <div class="bb-form-section">Assignment</div>
          <div class="row g-2">
            <div class="col-md-5">
              <label class="form-label">Manager <span class="text-danger">*</span></label>
              <select formControlName="managerId" class="form-select"
                      [class.is-invalid]="isFieldInvalid('managerId')">
                <option value="">-- Select Manager --</option>
                <option *ngFor="let m of managers" [value]="m._id">{{ m.name }}</option>
              </select>
              <div class="invalid-feedback">Manager is required.</div>
              <div class="form-text" *ngIf="managers.length === 0">No managers yet. Add a user with role = Manager first.</div>
            </div>
          </div>

        </div>

        <div class="bb-form-footer">
          <div class="bb-form-footer__msg">
            <span *ngIf="errorMessage" class="text-danger"><i class="pe-7s-close-circle me-1"></i>{{ errorMessage }}</span>
            <span *ngIf="successMessage" class="text-success"><i class="pe-7s-check me-1"></i>{{ successMessage }}</span>
          </div>
          <button type="submit" class="bb-btn-save" [disabled]="isSaving">
            <span *ngIf="!isSaving"><i class="pe-7s-diskette"></i> {{ isEditMode ? 'Update Center' : 'Save Center' }}</span>
            <span *ngIf="isSaving" class="d-flex align-items-center gap-1"><span class="spinner-border spinner-border-sm"></span> Saving...</span>
          </button>
        </div>
      </form>

    </div>
  </div>

</div>
